import { render } from "./ForgotPassword.vue?vue&type=template&id=52a79df0&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/ForgotPassword/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52a79df0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52a79df0', __exports__)) {
    api.reload('52a79df0', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=52a79df0&ts=true", () => {
    api.rerender('52a79df0', render)
  })

}


export default __exports__